import { forwardRef, Ref } from 'react';

import { rem, IconButton, Flex, IconButtonProps } from '@vimeo/bokeh';
import { AnyObject } from '@vimeo/core/types/generic';

export interface IBokehIconButtonProps extends Partial<IconButtonProps> {
  ariaLabel?: string;
  iconWidth?: string;
  iconHeight?: string;
  hoverColor?: AnyObject;
}

export const BokehIconButton = forwardRef(
  (
    {
      icon,
      isDisabled,
      ariaLabel = '',
      onClick,
      iconWidth = rem(20),
      iconHeight = rem(20),
      sx = {},
      size = 'sm',
      variant = 'tertiary',
      ...rest
    }: IBokehIconButtonProps,
    ref: Ref<HTMLElement>,
  ) => {
    return (
      <IconButton
        ref={ref}
        variant={variant}
        size={size}
        sx={{
          ...sx,
        }}
        icon={
          <Flex width={iconWidth} height={iconHeight} justifyContent="center" alignItems="center">
            {icon}
          </Flex>
        }
        isDisabled={isDisabled}
        onClick={onClick}
        aria-label={ariaLabel}
        {...rest}
      />
    );
  },
);
